export const updateFavicon = (faviconUrl) => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  };
  export const updateTitle = (pageTitle) => {
    let title = document.querySelector("title");
    if (!title) {
      title = document.createElement('title');
      document.head.appendChild(title);
    }
    title.textContent = pageTitle; 
  };
  